<template>
  <component
    :is="layoutComponent"
    :field="field"
    :errors="errors"
    :show-label="true"
  >
    <template slot="field">
      <div
        v-for="(option, index) in field.options"
        :key="option.value"
        :class="checkboxLayoutClass"
        class="custom-checkbox custom-control"
      >
        <input
          :id="field.attribute + index"
          v-model="fieldValue"
          :value="option.value"
          type="checkbox"
          class="custom-control-input"
        />
        <label
          :for="field.attribute + index"
          class="custom-control-label check-text"
        >
          {{ option.label }}
        </label>
      </div>
    </template>
  </component>
</template>

<script>
import { FormCheckboxesField } from "stylemix-base";

export default {
  name: "FormCustomCheckboxesField",
  extends: FormCheckboxesField,
};
</script>
